import * as React from 'react';
import type { SVGProps } from 'react';
const SvgReservation = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={28} height={29} fill="none" {...props}>
    <path fill="#B2B2B2" d="M10.25 0H4.625v3.75H.875v5.625h26.25V3.75h-3.75V0H17.75v3.75h-7.5zM27.125 13.125H.875v15h26.25z" />
  </svg>
);
export default SvgReservation;
